module.exports = __webpack_public_path__ + "img/数据服务.265fbb90.svg";